module.exports = "<div class=\"results-item\" style=\"min-height:auto; padding-top:18px\">\r\n    <p style=\"font-size:18px\">Better results were found in jurisdictions outside your current settings. <a tabindex=\"0\" style=\"cursor: pointer\" id=\"expand-to-all-jurisdictions\" aria-label=\"Expand search to find results outside your jurisdictions\" title=\"Expand search\">Expand search</a></p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/expand-jurisdictions-result.html
// module id = 414
// module chunks = 1